import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m12 19 7-7 3 3-7 7-3-3z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 7.586 7.586", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "11", cy: "11", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PenTool";
const PenTool = memo(themed(Icon));
export {
  PenTool
};
//# sourceMappingURL=pen-tool.js.map
